import { AfterViewChecked, ChangeDetectionStrategy, Component, OnChanges, OnInit, SimpleChange, Input } from '@angular/core';

import { BaseSearchResultsTableComponent } from './../../shared/base-search-results-table.component';
import { CaseIdentifier } from './../../shared/case-identifier';
import { CivilIdentitySearchCase } from '../civil-identity-search-case';

@Component({
  selector: 'app-civil-index-search-results-table',
  templateUrl: './civil-index-search-results-table.component.html',
  styleUrls: ['./civil-index-search-results-table.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush // this class will manage change detection for better performance
})
export class CivilIndexSearchResultsTableComponent extends BaseSearchResultsTableComponent implements OnChanges, OnInit, AfterViewChecked {
   @Input() cases: CivilIdentitySearchCase[];
   tableColumnHeaders: any[];    // result table
   tableColumnWidths: any[];

   private rowRequiringFocus = -1;
   private resultsTableId = 'case-index-search-results-table';
   rowFocusedFlags: boolean[];

   ngOnInit() {
     super.ngOnInit();
     this.tableColumnWidths =
        ['22%', '22%', '15%', '15%', '16%', '10%'];
     this.tableColumnHeaders = this.getResultTableColumnHeaders();

     // reset the header column widths (base column should have the same widths)
     let colCnt: number = this.tableColumnWidths.length;
     for (let idx = 0; idx <  colCnt ; idx++ ) {
        this.tableColumnHeaders[idx].headerWidth = this.tableColumnWidths[idx];
     }
   }

   /**
    * set the flags when the cases was pushed to this compoment
    * @param changes ;
    */
   ngOnChanges(changes: { [propName: string]: SimpleChange}) {
    // results loaded
    if (changes['cases'] && this.cases && this.cases.length) {
      this.rowRequiringFocus = changes['cases'].previousValue ? changes['cases'].previousValue.length : 0;

      // row focused flags
      this.rowFocusedFlags = new Array(this.cases.length).fill(false);
    }
  }

   /**
    * set the element focused after view checked
    */
   ngAfterViewChecked() {
     if (this.rowRequiringFocus > -1) {
       this.focusRow(this.rowRequiringFocus);
     }
   }

   private focusRow(rowNumber: number) {
    const firstfocusedEleId: string = 'case-index-search-results-row-' + rowNumber + '-action-view-case-lnk';
    const firstFocusedEle: HTMLElement = document.getElementById(firstfocusedEleId);

    if (firstFocusedEle) {
      setTimeout(() => {
        firstFocusedEle.focus();
      }, 0);
      this.rowRequiringFocus = -1;
    }
  }

  protected requestFocusForLastViewedCase() {
    const lastViewedCaseIdentifier = this.lastViewedCase;
    for (let i = 0; i < this.cases.length; i++) {
      if (this.cases[i].getCaseIdentifier().equals(lastViewedCaseIdentifier)) {
        this.focusRow(i);
        break;
      }
    }
  }

   /**
    * focused on any element in the row
    */
   focusedOnRow(row: number) {
    this.rowFocusedFlags[row] = true;
   }

   /**
    * blured on any element in the row
    */
   blurredOffRow(row: number) {
      this.rowFocusedFlags[row] = false;
   }

   /**
    *  get the display result table header list
    */
   private getResultTableColumnHeaders(): any[] {
      let columnHeaders = [
        { headerName: 'Affected Party',
          headerWidth: '15%',
          popoverTitle: 'Debtor',
          popoverShow: true,
          popoverContent: 'Affected Party description',
          popoverTemplate: ''
        },
        { headerName: 'Opposing Party',
          headerWidth: '15%',
          popoverTitle: 'Opposing Party',
          popoverShow: true,
          popoverContent: 'Opposing Party desription.',
          popoverTemplate: ''
        },
        { headerName: 'County',
          vcode: 'V017.a',
          vcodeDesc: '',
          headerNamePart2: 'Case Number',
          vcode2: 'V003.a',
          vcode2Desc: '',
          headerWidth: '15%',
          popoverTitle: 'County and Case Number',
          popoverShow: true,
          popoverContent: 'County and Case number description ',
          popoverTemplate: '<div>Indicates the status of the case.'
          + '<div class="popover-section"><b>NO PENDING ISSUES</b>- All issues on the case have an order result other than PENDING ORDER and there is no appeal on the case.</div>'
          + '<div class="popover-section"><b>PENDING ISSUE(S)</b> - Any issue on the case has either no order result or an order result of PENDING ORDER and there is no appeal on the case.</div>'
          + '<div class="popover-section"><b>APPEALED</b> - All issues on the case have an order result other than PENDING ORDER but there is an appeal on the case.</div>'
          + '<div class="popover-section"><b>PENDING ISSUE(S)/APPEALED</b> - Any issue on the case has either no order result or an order result of PENDING ORDER and there is an appeal on the case.</div>'
          + '</div>'
        },
         { headerName: 'Issue',
          vcode: '005.e',
          vcodeDesc: '',
          headerWidth: '20%',
          popoverTitle: 'Issue',
          popoverShow: true,
          popoverContent: 'Issues are specific claims for relief sought by the filing party. For example, Divorce, Money Owed, Default Judgment.',
          popoverTemplate: ''
        },
         { headerName: 'Judgment Location',
           vcode: 'v058.a',
           vcodeDesc: '',
           headerNamePart2: '(Judgment Status)',
           vcode2: 'V034.a',
           vcode2Desc: '',
          headerWidth: '15%',
          popoverTitle: 'Judgment Location',
          popoverShow: true,
          popoverContent: 'Judgment Location Description',
          popoverTemplate: ''
        },
        /*
        { headerName: 'Judgment',
          headerNamePart2: 'Status',
          headerWidth: '10%',
          popoverTitle: 'Judgment Status',
          popoverShow: true,
          popoverContent: 'A YES in this field indicates there are judgments associated with the case.',
          popoverTemplate: ''
        },*/
         { headerName: 'Actions',
          headerWidth: '10%',
          popoverTitle: 'Actions',
          popoverShow: true,
          popoverContent: 'Action Decription',
          popoverTemplate: '<div class="popover-section">Click &lt;View Case&gt; to see the details on the case.'
                      + '<div class="popover-section">Click &lt;Add To Cart&gt to add the case to the cart for printing or emailing.</div>'
                      + '</div>'
        }
      ];

      return columnHeaders;
   }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-index-search-results-table/civil-index-search-results-table.component.ts